export const staticWidget = {
  id: 'widget',
  schema: {
    type: 'object',
    properties: {},
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'Widget',
    uiType: 'widget',
    title: '',
    fieldName: 'Widget 1',
    isCanEdit: true,
    isCanDelete: true,
    action: { event: '', name: '' },
    elements: [],
    formData: false,
    layoutPadding: 0,
    isGroupValue: true,
  },
}
